import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import ErrorBoundary from './components/ErrorBoundary';
import App from './App';
import './index.css';

Sentry.init({
  dsn: 'https://529c8d25a909f7bf68c195bad1921843@o4511174509133024.ingest.de.sentry.io/4511174536921168',
  enabled: import.meta.env.PROD,
  integrations: [
    Sentry.browserTracingIntegration(),
  ],
  tracesSampleRate: 0.2,
});

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Failed to find the root element');
}

const root = createRoot(rootElement);

// Retrait du StrictMode pour éviter l'avertissement de ReactQuill
root.render(
  <Sentry.ErrorBoundary fallback={<ErrorBoundary children={<></>} />}>
    <ErrorBoundary>
      <AuthProvider>
        <ThemeProvider>
          <App />
        </ThemeProvider>
      </AuthProvider>
    </ErrorBoundary>
  </Sentry.ErrorBoundary>
);